<script setup>

import {  BTr,BTh} from 'bootstrap-vue-next';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import ButtonCta from '@/components/ButtonCta.vue';
import InvRoomHistory from './InvRoomHistory.vue';
import InvRoomDistribution from './InvRoomDistribution.vue';
import DataTable from '@/components/DataTable.vue';
import InventoryModalForm from '../InventoryModalForm.vue';
import {  reactive, watch, ref } from 'vue';

const historyTogle = ref(false)
const dataHistory = reactive({
  data : [],
})

const distributionTogle = ref(false)
const dataDistribution = reactive({
  current : "Last qty",
  new : "New qty",
  data : [],
  input : reactive({}),
})


const selectOption = reactive({
  roomType : 'Select Type',
  roomNumber : 'Select Room',
  item : 'Select Item',
  moveTo : 'Move to',
})

const inventoryModal = ref(false)

watch(()=>selectOption.roomNumber, () => {
  
  dataDistribution.current = `Last Qty : ${dataDistribution.data[selectOption.roomNumber]}`

})

const togleHistory = (theData) => {
  dataHistory.data = []
  dataHistory.togle = !dataHistory.togle
  dataHistory.data = historyitem.map(i => i.id == theData.id ? i : null).filter(i => i != null)

}

const togleDistribution = (data) => {
 
  
  dataDistribution.data = []
  dataDistribution.data.push(data)
  dataDistribution.input = data
  selectOption.item = data
}

const customActions = ref([
  {
      label: 'History',
      variant: 'secondary',
      icon: 'fas fa-history',
      action: (item) => {
        historyTogle.value = true
        togleHistory(item)
      // Implement your Info logic here
      }
  },
  {
      label: 'Distribution',
      variant: 'warning',
      icon: 'fas fa-share-alt',
      action: (item) => {
        distributionTogle.value = true
        togleDistribution(item)
      // Implement your Payment logic here
      }
  },
  
])

</script>

<template>
  <HeaderContent title="Room Inventory"/>
  <ActionContent :filterDate="false" :cta="false"></ActionContent>


    <div class="mt-4 table-responsive bg-white rounded-3 mb-0">
        <div class="p-4">
            <div class="d-lg-flex">
                <ButtonCta class="" v-if=" inventoryName !== 'spoil' && inventoryName !== 'overall' " text="Add New" show="true" @action="inventoryModal = !inventoryModal"></ButtonCta>
            </div>
        </div>
        <DataTable :data="items" :header="fields" :custom-actions="customActions">
          <template #thead-top>
            <BTr>
            <BTh colspan="3" ><span class="visually-hidden">ID, Name, Category </span></BTh>
            <BTh class="bg-danger" colspan="4">Deluxe</BTh>
            <BTh class="bg-orange" colspan="4">Family</BTh>
            <BTh class="bg-success" colspan="4">Studio</BTh>
            <BTh class="bg-primary" colspan="3">Honey Moon</BTh>
            </BTr>
          </template>
        </DataTable>

    </div>
   
    <InventoryModalForm v-model="inventoryModal" @update:modal="modal = $event"></InventoryModalForm>
    <InvRoomHistory 
      v-model="historyTogle" 
      :historyItem="dataHistory.data" 
      :historyHeader="historyHeader">

    </InvRoomHistory>
   
   <InvRoomDistribution 
    :title="selectOption.item.name" 
    v-model="distributionTogle" 
    :itemDis="itemDis" 
    :itemInRoom="dataDistribution.input" 
    :optionRoomType="option.room_type" 
    :optionRoomNumber="option.room_number">
    </InvRoomDistribution>
</template>




<script>


const fields = [
  
  {key: 'id', label: 'ID'},
  {key: 'name', label: 'Name',},
  {key: 'category', label: 'Category',},
  {key: 'A03', label: 'A03'},
  {key: 'A04', label: 'A04'},
  {key: 'A05', label: 'A05'},
  {key: 'A06', label: 'A06'},
  {key: 'B01', label: 'B01'},
  {key: 'B03', label: 'B03'},
  {key: 'B04', label: 'B04'},
  {key: 'B05', label: 'B05'},
  {key: 'C01', label: 'C01'},
  {key: 'C03', label: 'C03'},
  {key: 'C04', label: 'C04'},
  {key: 'C05', label: 'C05'},
  {key: 'D01', label: 'D01'},
  {key: 'D03', label: 'D03'},
  {key: 'D04', label: 'D04'},
  {key: 'action', label: 'Action'},
]

const items = [
  {
    id: 'I001',
    name: 'Double Sheet',
    category : 'item',
    A03: 2,
    A04: 1,
    A05: 1,
    A06: 1,
    B01: 2,
    B03: 1,
    B04: 1,
    B05: 1,
    C01: 2,
    C03: 2,
    C04: 2,
    C05: 3,
    D01: 2,
    D03: 2,
    D04: 2,
  },
  {
    id: 'I002',
    name: 'Single Sheet',
    category : 'item',
    A03: 1,
    A04: 1,
    A05: 1,
    A06: 1,
    B01: 2,
    B03: 1,
    B04: 1,
    B05: 1,
    C01: 2,
    C03: 2,
    C04: 2,
    C05: 3,
    D01: 2,
    D03: 2,
    D04: 2,
  },
  {
    id: 'I003',
    name: 'Bath Towel',
    category : 'item',
    A03: 3,
    A04: 1,
    A05: 1,
    A06: 1,
    B01: 2,
    B03: 1,
    B04: 1,
    B05: 1,
    C01: 2,
    C03: 2,
    C04: 2,
    C05: 3,
    D01: 2,
    D03: 2,
    D04: 2,
  },
  {
    id: 'P001',
    name: 'Tooth Paste',
    category : 'Product',
    A03: 4,
    A04: 1,
    A05: 1,
    A06: 1,
    B01: 2,
    B03: 1,
    B04: 1,
    B05: 1,
    C01: 2,
    C03: 2,
    C04: 2,
    C05: 3,
    D01: 2,
    D03: 2,
    D04: 2,
  },
  {
    id: 'P002',
    name: 'Soft Drink',
    category : 'Product',
    A03: 5,
    A04: 1,
    A05: 1,
    A06: 1,
    B01: 2,
    B03: 1,
    B04: 1,
    B05: 1,
    C01: 2,
    C03: 2,
    C04: 2,
    C05: 3,
    D01: 2,
    D03: 2,
    D04: 2,
  },
  {
    id: 'P003',
    name: 'Snacks',
    category : 'Product',
    A03: 6,
    A04: 1,
    A05: 1,
    A06: 1,
    B01: 2,
    B03: 1,
    B04: 1,
    B05: 1,
    C01: 2,
    C03: 2,
    C04: 2,
    C05: 3,
    D01: 2,
    D03: 2,
    D04: 2,
    
  },
  
]

const itemDis = [
  {
    type : 'Deluxe',
    room : [
    {
      A03: 1,
      A04: 1,
      A05: 1,
      A06: 1,
      
    }
    ]
  },
  {
    type : 'Family',
    room : [
    {
      B01: 1,
      B03: 1,
      B04: 1,
      B05: 1,
      
    }
    ]
  },
  {
    type : 'Studio',
    room : [
    {
      C01: 1,
      C03: 1,
      C04: 1,
      C05: 1,
      
    }
    ]
  },
  {
    type : 'Honey Moon',
    room : [
    {
      D01: 1,
      D03: 1,
      D04: 1,
    }
    ]
  },
  
  
  
  
]

const historyitem = [
{
    id: 'I002',
    name: 'Single Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I001',
    name: 'Double Sheet',
    category : 'item',
    qty : 2,
    desc : "Added item to room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I001',
    name: 'Double Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Spoil",
    remark : 'Rusak karena puntung rokok',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I002',
    name: 'Single Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I003',
    name: 'Single Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
]


const option = {
    room_type:[
      {
        value : 'Select Type',
        text : 'Select Type'
      },
      {
        value : 'Deluxe',
        text : 'Deluxe'
      },
      {
        value : 'Super Deluxe',
        text : 'Super Deluxe'
      },
      {
        value : 'Suite',
        text : 'Suite'
      },
      {
        value : 'Family',
        text : 'Family'
      },
      
    ],
    room_number : [
      {
        value : 'Select Room',
        text : 'Select Room'
      },
      {
        value : 'A03',
        text : 'A03'
      },
      
      {
        value : 'A04',      
        text : 'A04'
      },
      {
        value : 'B01',      
        text : 'B01'
      },
      {
        value : 'B03',      
        text : 'B03'
      },
      {
        value : 'C01',      
        text : 'C01'
      },
      {
        value : 'C03',      
        text : 'C03'
      },
    ],
    item : [
      {
        value : 'Select Item',
        text : 'Select Item'
      },
      {
        value : 'Double Sheet',
        text : 'Double Sheet'
      },
      {
        value : 'Single Sheet',      
        text : 'Single Sheet'
      },
      {
        value : 'Bath Towel',      
        text : 'Bath Towel'
      },
    ],
  
    
}

</script>